import { render, staticRenderFns } from "./1326_灌溉花园的最少水龙头数目.md?vue&type=template&id=54a66425&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports